import React, { useState, useEffect } from "react";
import Tab5Image from "../img/envision/mechanicalenginering/mechimg1.jpg";
import Tab4Image from "../img/envision/manufacturing/supplychain-manufacturing.jpg";
import Tab3Image from "../img/envision/manufacturing/manfaturetabtwo/cybersecuritymanfature.jpg";
import Tab2Image from "../img/envision/manufacturing/manfaturetabtwo/qualitymangment-manufaturing.jpg";
import Tab1Image from "../img/envision/manufacturing/pci standards.jpg";
// import Tab5Image from "../img/envision/aerospace/tabsimages/[freepicdownloader.com]-generative-ai-military-fighter-jets-patrol-air-launch-missiles-medium.jpg";
// import Tab6Image from "../img/envision/aerospace/tabsimages/jhkk.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTruck, faGear, faMicrochip, faSlidersH, faWifi, faCogs, faCloud, faVial, faTablet, faNetworkWired, faDesktop, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const Manufacturingsecondtabs = () => {
    const [activeTab, setActiveTab] = useState("tab1");
  const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay

    // const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate(); // Initialize navigate

  //  const handleKnowMoreClick = () => {
  //          // Navigate to the documentaerospacepage with the specific hash
  //          navigate("/documnetmanufacturepage#documnetmanufacturepageSEeconddata");
  //        };

  const handleKnowMoreClick = (tab) => {
    navigate(`/documnetmanufacturepage?tab=${tab}#documnetmanufacturepageSEeconddata`);
};
        const [isHovered, setIsHovered] = useState(false);
        const handleTabClick = (tabId) => {
            setActiveTab(tabId);
            setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
          };
         // Autoplay effect to change tabs every 3 seconds (3000ms)
          useEffect(() => {
                    let tabInterval;
                
                    if (!isHovered && isAutoPlayActive) {
                      tabInterval = setInterval(() => {
                        setActiveTab((prevTab) => {
                          const nextTabNum = parseInt(prevTab.replace("tab", "")) % 4 + 1;
                          return `tab${nextTabNum}`;
                        });
                      }, 3000);
                    }
                
                    return () => clearInterval(tabInterval);
                  }, [activeTab, isHovered, isAutoPlayActive]);
                
              
       
    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            // display: "flex",
            width: "80%",
            margin: "50px auto",
        },
        tabNav: {
            // display: "flex",
            flexDirection: "column",
            borderRight: "1px solid #fff",
            height: "380px",
            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
            direction: "rtl", // This makes the scrollbar appear on the left side
        },

        tabButton: {
            padding: "25px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {
            // display: "flex",
            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            // marginLeft: "10px",
            cursor:"pointer",
        },
        image: {
            width: "382px",
            height: "354px",
            borderRadius: "10px",
            marginRight: "20px",
        },
        textContent: {
            flex: 1,
            textAlign: "left",
            color: "#333",
            height:"355px",
            overflow:"auto",
        },
        icon: {
            marginRight: "10px",
            fontSize: "24px",
            color: "#009ca5",
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            // marginLeft: "150px"
        },
        knowMoreButtonHover: {
            backgroundColor: "#e68a00",
        },
    };

    return (
        <div style={{ marginTop: '100px' }}>
        <h1 style={{ textAlign: "center" }}>
        <span style={{ color: "rgb(236 115 34)" }}> Integrated (ISO-PCI) </span>  Compliance services
        </h1>
    
        <div style={styles.container} className="tabclass-container-data">
            {/* Tab Navigation */}
            <div style={styles.tabNav} className="tabdata">
                <button
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => handleTabClick("tab1")}
                 className="tab-button-width"
                 onMouseEnter={(e) => {
                    if (activeTab !== "tab1") {
                      e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                      e.currentTarget.style.color = "#fff"; // Change text to white
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeTab !== "tab1") {
                      e.currentTarget.style.backgroundColor = ""; // Revert background
                      e.currentTarget.style.color = ""; // Revert text color
                    }
                  }}
              
                >
                   PCI standards	
                </button>
                <button
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => handleTabClick("tab2")}
                 className="tab-button-width"
                 onMouseEnter={(e) => {
                    if (activeTab !== "tab2") {
                      e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                      e.currentTarget.style.color = "#fff"; // Change text to white
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeTab !== "tab2") {
                      e.currentTarget.style.backgroundColor = ""; // Revert background
                      e.currentTarget.style.color = ""; // Revert text color
                    }
                  }}
              
                >
                  Quality Management & Product Safety standards 
                </button>
                <button
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "tab3" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => handleTabClick("tab3")}
                 className="tab-button-width"
                 onMouseEnter={(e) => {
                    if (activeTab !== "tab3") {
                      e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                      e.currentTarget.style.color = "#fff"; // Change text to white
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeTab !== "tab3") {
                      e.currentTarget.style.backgroundColor = ""; // Revert background
                      e.currentTarget.style.color = ""; // Revert text color
                    }
                  }}
              
                >
                 Cybersecurity & IT Systems in Manufacturing standards
                </button>
                <button
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "tab4" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => handleTabClick("tab4")}
                 className="tab-button-width"
                 onMouseEnter={(e) => {
                    if (activeTab !== "tab4") {
                      e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                      e.currentTarget.style.color = "#fff"; // Change text to white
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeTab !== "tab4") {
                      e.currentTarget.style.backgroundColor = ""; // Revert background
                      e.currentTarget.style.color = ""; // Revert text color
                    }
                  }}
              
                >
                 Supply Chain & Risk Management standards
                </button>
            </div>
    
            {/* Tab Content */}
            <div style={styles.card} className="card-data-vertica-tabs" onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}>
                <img
                    src={{ tab1: Tab1Image, tab2: Tab2Image, tab3: Tab3Image, tab4: Tab4Image }[activeTab]}
                    alt="Aerospace"
                    style={styles.image}
                     className="tab-image-data"
                />
                <div style={styles.textContent}>
                    {(() => {
                        const tabIndex = parseInt(activeTab.replace("tab", "")) - 1;
                        const contentArray = [
                            [
                                " PCI DSS v4.0 – General security standards for payment processing, preventing fraud.",
                                " PCI PTS – Secure PIN transaction systems for ATMs, POS, and payment devices.",
                                " PCI PA-DSS – Secure software development standards for financial applications.",
                                " PCI SSF (Software Security Framework) – Security framework for financial applications.",
                            ],
                            [
                                " ISO 9001 – Quality Management System (QMS) for manufacturing operations.",
                                " ISO 14001 – Environmental Management System (EMS) for sustainable manufacturing.",
                                " ISO 45001 – Occupational Health & Safety Management (OHS) for worker protection + Energy Management System (EMS) for energy-efficient manufacturing.",
                                " ISO 31000 – Risk management framework for manufacturing supply chains.",
                                " ISO 37301 – Compliance management system for regulatory adherence in manufacturing",    
                            ],
                            [
                                " ISO/IEC 27001 – Information security management for factory IT & OT networks.",
                                " ISO/IEC 27701 – Data privacy management for manufacturers handling customer data.",
                                " ISO/IEC 62443 – Cybersecurity for industrial automation & control systems (IACS).",
                                " ISO 20000-1 – IT service management system for smart manufacturing infrastructure.",
                            ],
                            [
                                " ISO 28000 – Supply chain security risk management system.",
                                " ISO 22301 – Business continuity management for manufacturing disruptions.",
                                " ISO 55001 – Asset management for production equipment and facilities.",
                            ]
                        ];
    
                        // Ensure the selected content is within range and not undefined
                        const selectedContent = contentArray[tabIndex] || [];
    
                        return selectedContent.map((point, index) => (
                            <ul key={index}>
                                <li>{point}</li>
                            </ul>
                        ));
                    })()}
    
                    {/* <button
                        style={styles.knowMoreButton}
                        onClick={handleKnowMoreClick}
                        onMouseEnter={(e) => (e.target.style.backgroundColor = "#e68a00")}
                        onMouseLeave={(e) => (e.target.style.backgroundColor = "rgb(236 115 34)")}
                    className="know-more-btn"
                    >
                        Know More
                    </button> */}
                       {["tab1", "tab2", "tab3","tab4"].includes(activeTab) && (
                            <button   style={{ ...styles.knowMoreButton, ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}) }}
                             onClick={() => handleKnowMoreClick(activeTab)} className="know-more-btn">
                                Know More
                            </button>
                        )}
                </div>
            </div>
        </div>
    
        {/* Dot Navigation for 3 Tabs */}
        <div style={styles.dotNav}>
            {[...Array(4)].map((_, index) => {
                const tab = `tab${index + 1}`;
                return (
                    <div
                        key={tab}
                        style={{
                            ...styles.dot,
                            ...(activeTab === tab ? styles.activeDot : {}),
                        }}
                        onClick={() => handleTabClick(tab)}
                    />
                );
            })}
        </div>
    </div>
    
    );
};

export default Manufacturingsecondtabs;
